import Accordion from 'react-bootstrap/Accordion';

const VersionHighlight = () => {
  return (
    <div>
      <Accordion defaultActiveKey='0'>
        <Accordion.Item>
          <Accordion.Header>
            <div>
              <div>
                <strong>Version 2.2.3</strong>
              </div>
              <div>
                <small>What's New</small>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <p>
              The new alphabet scroll bar allows you to quickly navigate through your library by
              jumping to items that start with a specific letter.
            </p>
            <p>
              <em>
                Security updates are in place; if you run into issues, try logging out and back in
                via the menu.
              </em>
            </p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default VersionHighlight;
